import { useState } from 'react';

import { SlackChannel, SubscriptionType } from 'models';

import { LocalNotificationService } from 'services/LocalNotificationService';
import { SlackNotificationService } from 'services/SlackNotificationService';
import { TeamService } from 'services/TeamService';

import { SubscriptionUpdateCommonProps } from '../types';

export const useSubscriptionUnsubscribe = <T extends SubscriptionType>({
    type,
    team,
    onClose,
    postSubmitAction,
}: { type: T } & SubscriptionUpdateCommonProps) => {
    const [loading, setLoading] = useState(false);

    const submitSubscriptionUnsubscribe = async () => {
        setLoading(true);

        try {
            await TeamService.subscriptionUnsubscribe(team.id, type);

            if (postSubmitAction) {
                postSubmitAction();
            }

            onClose();

            LocalNotificationService.showSuccess({ message: 'Subscription unsubscribed successfully' });

            TeamService.refresh(team.id);
        } catch (error) {
            console.error('Error unsubscribing from subscription', error);
            LocalNotificationService.showError({ message: 'Error unsubscribing from subscription' });

            SlackNotificationService.send(
                [
                    '*User Encountered Error Unsubscribing from Subscription*',
                    `Team: ${team.name} (${team.id})`,
                    `Subscription Unsubscribe Attempted: ${type}`,
                    `Error message: ${JSON.stringify(error)}`,
                ].join('\n'),
                SlackChannel.PAYMENT,
            );
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        submitSubscriptionUnsubscribe,
    };
};
